import React from 'react';
import { motion } from 'framer-motion';
import { Clock, FileQuestion, ShuffleIcon, Brain, AlertTriangle } from 'lucide-react';
const struggles = [{
  icon: Clock,
  text: 'Pasás horas buscando material útil que sea realmente aplicable.'
}, {
  icon: ShuffleIcon,
  text: 'Repetís tareas que ya deberías tener resueltas y a mano.'
}, {
  icon: FileQuestion,
  text: 'Te cuesta organizar evaluaciones, planes e intervenciones.'
}, {
  icon: Brain,
  text: 'Sentís que podrías trabajar mejor, pero no te alcanza el tiempo.'
}, {
  icon: AlertTriangle,
  text: 'Tu trabajo pierde fluidez por falta de recursos listos para usar.'
}];
export function PainSection() {
  return <section className="py-8 bg-transparent relative" data-id="element-122">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-123">
        <div className="text-center mb-10" data-id="element-124">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-orange-500/10 border border-orange-500/30 text-orange-300 text-[11px] font-bold tracking-[0.18em] uppercase mb-5" data-id="element-125">
            ¿Te suena familiar?
          </motion.div>
          <h2 className="text-3xl md:text-4xl font-bold leading-tight" data-id="element-126">
            Si sos fonoaudiólogo,{' '}
            <span className="text-gradient" data-id="element-127">seguro te pasa</span>
          </h2>
        </div>

        <ul className="space-y-3" data-id="element-128">
          {struggles.map((item, i) => <motion.li key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08,
          duration: 0.45
        }} className="group flex items-center gap-4 p-4 md:p-5 rounded-2xl bg-white/[0.02] border border-white/10 hover:border-orange-500/50 hover:bg-orange-500/[0.04] transition-all" data-id="element-129">
              <div className="shrink-0 w-11 h-11 rounded-xl bg-orange-500/10 border border-orange-500/30 flex items-center justify-center text-orange-400 group-hover:bg-orange-500/20 group-hover:text-orange-300 transition-colors" data-id="element-130">
                <item.icon className="w-5 h-5" data-id="element-131" />
              </div>
              <p className="text-[15px] md:text-base text-gray-200 font-medium leading-snug" data-id="element-132">
                {item.text}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}